import APITemplate from '@api/APITemplate'
// import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
// import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { asset } from '@modules/consolidator/constants/URL.js'
import { acoesLoteConsolidador, cadastroAtivo } from '@constants/URL'
import { buildEditInBatchPayload } from '@modules/consolidator/utils/bulk-flag-action/bulk-flag-action'

class APIConsolidatorClientAssets extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  // async carregar(forceUpdate = false) {
  //   if (this.reqCarregar) {
  //     return this.reqCarregar
  //   }
  //   if (!forceUpdate) {
  //     if (
  //       !diffTimeMinutes(
  //         store.getters['consolidator/clientAssetsLastUpdate'],
  //         MINUTES_TIMEOUT_REQUESTS
  //       )
  //     ) {
  //       return store.getters['consolidator/clientAssets']
  //     }
  //   }

  //   if (store.getters['consolidator/clientAssetsLoading']) {
  //     return store.getters['consolidator/clientAssets']
  //   }

  //   store.dispatch('consolidator/setClientAssetsLoading', true)

  //   this.reqCarregar = con.get(dev.espelho)
  //   const r = await this.reqCarregar

  //   if (r && r.status === 200) {
  //     store.dispatch('consolidator/setClientAssets', r.value || [])
  //   } else {
  //     store.dispatch('consolidator/setClientAssets', [])
  //   }

  //   store.dispatch('consolidator/setClientAssetsLoading', false)

  //   this.reqCarregar = null

  //   return r || {}
  // }

  // async salvar({ id }) {
  //   const dado = {
  //     id,
  //   }

  //   const data = {
  //     data: JSON.stringify(dado),
  //   }

  //   let r
  //   if (id > 0) {
  //     r = await con.put(dev.espelho, data)
  //   } else {
  //     r = await con.post(dev.espelho, data)
  //   }

  //   if (r && r.status === 200) {
  //     store.dispatch('consolidator/addClientAssets', r.value[0] || r.value || {})
  //   }

  //   return r || {}
  // }

  async editInBatch({ idCliente, idsAtivos, dadosAtivo, isCliente }) {
    const payload = buildEditInBatchPayload({
      idCliente,
      idsAtivos,
      dadosAtivo,
      isCliente,
      endpoints: acoesLoteConsolidador,
    })
    if (!payload.ok) return payload.errorResponse
    const r = await con.put(payload.url, payload.data)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async removeAsset({ ativo, idCliente, isCliente, limparExtrato } = {}) {
    if (!ativo || !ativo.id) {
      return { status: 404, message: 'Ativo não encontrado.', value: null }
    }

    const data = {
      id_conta: ativo.id_conta,
      nome_ativo: ativo.nome_ativo,
      limpar_extrato: limparExtrato,
      id: ativo.id,
    }

    let r
    if (isCliente) {
      r = await con.post(cadastroAtivo.ativos.remover, data)
    } else {
      data.id_cliente_app = idCliente
      r = await con.delet(cadastroAtivo.profissional + ativo.id, data)
    }

    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async deleteInBatch({ idCliente, idsAtivos }) {
    if (!idCliente) {
      return {
        status: 404,
        message: 'Cliente não encontrado.',
      }
    }

    const data = {
      id_cliente_app: idCliente,
      ids_ativos: idsAtivos,
    }

    store.dispatch('consolidator/setClientAssetsLoading', true)

    const r = await con.delet(asset.deleteInBatch, data)

    store.dispatch('consolidator/setClientAssetsLoading', false)

    // if (r && r.status === 200) {
    //   this.carregar(true)
    // }

    return r || {}
  }
}

const apiConsolidatorClientAssets = new APIConsolidatorClientAssets()
export { apiConsolidatorClientAssets }
